<script>
export default {
  props: {
    socialToken: {
      type: String,
      required: true
    },
    token: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  render: () => null,
  mounted () {
    axios.get('/sanctum/csrf-cookie').then(() => {
      // This effectively logs in the user
      this.$store.commit('user/dismissAuthMessage')

      // Set token
      this.$store.commit('user/token', this.token)
      this.$store.dispatch('user/setAuthHeader')

      // Save our user details
      this.$store.commit('user/authenticated', this.user)

      // And show our login panel
      this.$store.commit('user/dismissAuth')

      // If we can go back to where we left off, do so
      if (this.$store.getters['account/canRevert']) {
        this.$store.dispatch('account/commitMutation', {
          mutation: 'navigateToReversion'
        })
      } else {
        this.$store.dispatch('account/commitMutation', {
          mutation: 'open',
          data: this.$store.getters['user/shouldCompleteProfile']
        })
      }

      this.$emit('loggedIn')

      this.$toasted.show(
          `Thanks ${this.user.first_name}, you've logged in successfully.`, {
            type: 'success'
          })

      this.$destroy()
    })
  }
}
</script>
